import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {Injectable} from "@angular/core";

import {IDataFilter} from "../../services/DataTable";
import {IDataModel} from "../../services/IDataModel";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {FilesModel} from "./files.model";
import {ApplicationUser} from "../../services/ApplicationUser";

@Injectable()
export class FilesService implements IDataModel {

    private API_ROOT:string = '/files';

    constructor(private http:Http) {

    }

    getList(filter:IDataFilter): Observable<ListResponseModel<FilesModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getOne(id:number):Observable<ResponseModel<FilesModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    getPricingFiles(id:number):Observable<any>{
        return this.http.get(`${this.API_ROOT}/pricing/${id}`).map((res) => res.json());
    }

    getClientFiles(id:number):Observable<any>{
        return this.http.get(`${this.API_ROOT}/client/${id}`).map((res) => res.json());
    }

    getPreviewFiles(pricing_id:string, files:string, client_id?: string):Observable<any>{
        let params: URLSearchParams = new URLSearchParams();
        if (pricing_id) params.set('pricing_id', pricing_id);
        if (files) params.set('files', files);
        if (client_id) params.set('client_id', client_id);

        return this.http.get(`${this.API_ROOT}/preview`,  new RequestOptions({
            search: params
        })).map((res) => res.json());
    }

    hasArchive(client_id: any):Observable<any> {
        return this.http.get(`${this.API_ROOT}/has-archive/${client_id}`).map((res) => res.json());
    }

    add(fields:FilesModel): Observable<ResponseModel<FilesModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    static getFileContentUrl(fileId){
        let user = ApplicationUser.getInstance();
        return'/api/v1/files/content/' + fileId + '?Authorization=' + user.getAccessToken();
    }

}


// WEBPACK FOOTER //
// ./src/app/models/files/files.service.ts